import { createSlice } from '@reduxjs/toolkit';
import { CurrencyInfo } from '../types/currency';
import type { PayloadAction } from '@reduxjs/toolkit';
import { getCurrenciesApi } from '../services/Currencies/currencies';
import { createQuery } from '../utils/constants';

interface InitialState {
  currencies: CurrencyInfo[];
}

interface Filter {}

const initialState: InitialState = {
  currencies: [],
};

export const weightUnitSlice = createSlice({
  name: 'currency',
  initialState,
  reducers: {
    getAll: (state, action: PayloadAction<any>) => {
      state.currencies = action.payload.manufacturers;
    },
    setAll: (state, action: PayloadAction<any>) => {
      state.currencies = action.payload;
    },
  },
});

export const { getAll, setAll } = weightUnitSlice.actions;
export default weightUnitSlice.reducer;

export const getCurrenciesAction = (payload: any) => async (dispatch: any, getState: any) => {
  try {
    const { filter } = getState().currency;
    const queryParams = { ...filter, ...payload };
    const query = '?' + createQuery({ filter: queryParams });

    const response = await getCurrenciesApi(query);
    if (response.kind === 'ok') {
      const { pagination, data: list } = response.data;

      dispatch(setAll(list));
    }
  } catch (error) {
  } finally {
  }
};
